import { render, staticRenderFns } from "./ResellerViewOrganizations.vue?vue&type=template&id=0fae4063"
import script from "./ResellerViewOrganizations.vue?vue&type=script&lang=js"
export * from "./ResellerViewOrganizations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports